import { baseUrl } from './http.js';

export async function get(id) {
    const response = await fetch(`${baseUrl()}voucher/${id}`, {
        credentials: 'include',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
    });

    return response.json();
}
